// Safe UK phone normalizer
const formatUKPhone = (num = "") => {
  if (!num) return "";
  const clean = num.replace(/\s+/g, ""); // remove spaces
  if (clean.startsWith("44")) {
    return "0" + clean.slice(2); // remove '44' and add leading zero
  }
  return clean; // leave unchanged if it doesn't start with 44
};

export default formatUKPhone;